<script setup>
import { computed } from 'vue';
import ProfileIcon from '@/assets/listing/man profile.svg';
import ArrowRightIcon from '@/assets/icons/arrow-right.svg';
import { MESSAGE_ROLES } from './MessageRoles';

const { message, messageRole } = defineProps({
  message: {
    type: String,
    required: true,
  },
  messageRole: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(['insert']);

const fromUser = computed(() => MESSAGE_ROLES.User === messageRole);
const fromAssistant = computed(() => MESSAGE_ROLES.Assistant === messageRole);
</script>

<template>
  <div class="message-container">
    <div class="role-image" :class="fromUser ? 'bg-yellow' : 'bg-green'">
      <ProfileIcon v-if="fromUser" class="user" />
      <span v-else class="assistant">W</span>
    </div>

    <div class="text">
      <div v-html="message" />

      <button v-if="fromAssistant" class="main-button button-create" @click="emit('insert')">
        <ArrowRightIcon class="icon" />
        Insérer
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@/styles/colors.scss';

.message-container {
  display: flex;
  flex-direction: row;
  gap: 8px;

  &:first-child {
    button {
      display: none;
    }
  }

  > .role-image {
    width: 24px;
    height: 24px;
    border-radius: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    flex-shrink: 0;

    &.bg-yellow {
      background: colors.$yellow-color;
    }

    &.bg-green {
      background: colors.$light-blue-color;
    }

    > .user {
      width: 10px;
      height: 10px;
      color: colors.$white-color;
    }

    > .assistant {
      color: colors.$white-color;
      font-weight: bold;
    }
  }

  > .text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;

    > button {
      margin: 0;
      width: auto;
      padding: 5px 10px;

      display: flex;
      gap: 8px;

      > .icon {
        height: 8px;
        transform: rotate(180deg);
      }
    }
  }
}
</style>
